import queryString from 'querystring'
import { useParams, useLocation, useHistory, useRouteMatch } from 'react-router'
import { useContext, useMemo } from 'react'
import { IonRouterContext } from '@ionic/react'
export default function useRouter() {
  const params = useParams()
  const location = useLocation()
  const history = useHistory()
  const match = useRouteMatch()
  const routerContext = useContext(IonRouterContext)

  // Return our custom router object
  // Memoize so that a new object is only returned if something changes
  return useMemo(() => {
    return {
      // For convenience add push(), replace(), pathname at top level
      pushURL: (url: string) => routerContext.push(url, 'forward'),
      replaceURL: (url: string) => routerContext.push(url, 'root'),
      popURL: () => {
        if (routerContext.canGoBack()) {
          routerContext.back()
        }
      },
      pathname: location.pathname,
      // Merge params and parsed query string into single "query" object
      // so that they can be used interchangeably.
      // Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
      query: {
        ...queryString.parse(location.search), // Convert string to object
        ...params,
      } as any,
      // Include match, location, history objects so we have
      // access to extra React Router functionality if needed.
      match,
      location,
      history,
      router: routerContext,
    }
  }, [params, match, location, history, routerContext])
}
